import PopupDeleteRestoreCustomer from './PopupDeleteRestoreCustomer';

export default PopupDeleteRestoreCustomer;
